module.exports = __webpack_public_path__ + "static/media/480.2c339ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-digger/light/480.png
// module id = 1996
// module chunks = 2